import { render, staticRenderFns } from "./OrderStepSuccess.vue?vue&type=template&id=5794a4a3&scoped=true&"
import script from "./OrderStepSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderStepSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OrderStepSuccess.vue?vue&type=style&index=0&id=5794a4a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794a4a3",
  null
  
)

component.options.__file = "OrderStepSuccess.vue"
export default component.exports